import { FC } from 'react';
import { darkColors } from '@tryhackme/thm-ui-components';
import { ThemeProvider, useTheme } from 'styled-components';
import crownImage from 'src/images/pngs/campaigns/beat-the-price-hike/crown.png';
import { Countdown } from '../../components/countdown';
import { useActiveCampaign } from '../../hooks/use-active-campaign';
import { StyledCard, StyledCrownImage, StyledSubtitle, StyledTimerMessage, StyledTitle } from './beat-the-price-hike-account-card.styles';
export const BeatTheHikePriceAccountCard: FC = () => {
  const theme = useTheme();
  const {
    campaign
  } = useActiveCampaign();
  return campaign ? <ThemeProvider theme={{
    ...theme,
    colors: darkColors
  }}>
      <StyledCard>
        <StyledCrownImage src={crownImage} />
        <StyledTitle>SAVE BIG BEFORE PRICES GO UP!</StyledTitle>
        <StyledSubtitle>
          <span>{campaign.amount}% off</span> annual subscriptions
        </StyledSubtitle>
        <StyledTimerMessage>Sale ends in:</StyledTimerMessage>
        <Countdown includeDays dark vertical startTime={campaign.startTime} endTime={campaign.endTime} />
      </StyledCard>
    </ThemeProvider> : null;
};